import React from 'react';
import { Link } from 'react-router-dom';

export function KpiCard({ icon: Icon, label, value, sublabel, type = 'neutral', to, onClick }) {
  const Wrap = to ? Link : onClick ? 'button' : 'div';
  const clickable = !!(to || onClick);
  
  const typeStyles = {
    neutral: {
      bar: 'border-l-tw1-brand-navy',
      chipBg: 'bg-[#eef1f7]',
      chipIcon: 'text-tw1-brand-navy'
    },
    attention: {
      bar: 'border-l-tw1-accent-gold',
      chipBg: 'bg-[#fdf3da]',
      chipIcon: 'text-[#9a6b16]'
    },
    danger: {
      bar: 'border-l-tw1-status-danger',
      chipBg: 'bg-[#f8e6e4]',
      chipIcon: 'text-[#9a3232]'
    }
  };

  const style = typeStyles[type] || typeStyles.neutral;

  return (
    <Wrap
      to={to}
      onClick={onClick}
      type={onClick && !to ? 'button' : undefined}
      data-testid={`kpi-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
      className={`relative w-full text-left overflow-hidden rounded-lg border border-[#e4e9f0] bg-white p-4 shadow-sm transition-all border-l-[3px] ${style.bar} ${clickable ? 'hover:border-tw1-brand-navy/30 hover:shadow-md cursor-pointer' : ''}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-3xl font-bold tabular-nums text-tw1-brand-navy">{value}</p>
          <p className="mt-1 text-xs font-medium uppercase tracking-wider text-tw1-text-muted">{label}</p>
          {sublabel && <p className="mt-0.5 text-[11px] text-tw1-text-muted-light">{sublabel}</p>}
        </div>
        <div className={`flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-lg ${style.chipBg} ${style.chipIcon}`}>
          <Icon size={18} />
        </div>
      </div>
    </Wrap>
  );
}
